/* global SideDrawer */

/**
 * Pyjama Mix & Match — quickview drawer + structured ATC button helpers.
 */
(function () {
  if (window.PyjamaMixMatch) return;

  const PyjamaMixMatch = {
    drawer: null,
    abortController: null,

    init() {
      this.drawer = document.querySelector('.js-pyjama-quickview-drawer');
      if (!this.drawer) return;

      document.addEventListener('click', this.handleClick.bind(this));
    },

    handleClick(evt) {
      const toggle = evt.target.closest('[data-pyjama-quickview-toggle]');
      if (!toggle || toggle.disabled) return;

      evt.preventDefault();
      this.openQuickview(toggle);
    },

    openQuickview(toggle) {
      const productUrl = toggle.dataset.productUrl;
      if (!productUrl) return;

      const title = toggle.dataset.productTitle || '';
      const price = toggle.dataset.productPrice || '';

      this.setDrawerHeader(title, price);
      this.setDrawerBodyLoading();
      this.drawer.open(toggle);

      if (this.abortController) {
        this.abortController.abort();
      }
      this.abortController = new AbortController();

      toggle.classList.add('loading');
      toggle.setAttribute('aria-busy', 'true');

      fetch(productUrl, {
        method: 'get',
        signal: this.abortController.signal
      })
        .then((response) => {
          if (!response.ok) throw new Error(`HTTP ${response.status}`);
          return response.text();
        })
        .then((html) => {
          const tmpl = document.createElement('template');
          tmpl.innerHTML = html;
          const quickbuyContent = tmpl.content.querySelector('.quickbuy-content');

          if (!quickbuyContent) {
            throw new Error('Quickview content not found');
          }

          const detail = quickbuyContent.cloneNode(true);

          if (theme.quickBuy && theme.quickBuy.convertToQuickBuyContent) {
            theme.quickBuy.convertToQuickBuyContent(detail, productUrl);
          }

          detail.querySelectorAll('modal-dialog, .pyjama-size-chart, .pyjama-mix-match-upsell, .pyjama-mix-match-banner').forEach((el) => {
            el.remove();
          });

          tmpl.content.querySelectorAll(':is(.section-main-product, .section-size-guide) link[rel="stylesheet"]').forEach((el) => {
            if (!document.querySelector(`link[rel="stylesheet"][href="${el.getAttribute('href')}"]`)) {
              document.head.insertAdjacentHTML('beforeend', el.outerHTML);
            }
          });

          tmpl.content.querySelectorAll(':is(.section-main-product, .section-size-guide) script[src]').forEach((el) => {
            if (!document.querySelector(`script[src="${el.getAttribute('src')}"]`)) {
              const scr = document.createElement('script');
              scr.src = el.getAttribute('src');
              scr.defer = 'defer';
              document.head.appendChild(scr);
            }
          });

          const body = this.drawer.querySelector('[data-pyjama-quickview-body]');
          const quickbuyWrapper = document.createElement('div');
          quickbuyWrapper.className = 'js-quickbuy pyjama-quickview-drawer__quickbuy';
          quickbuyWrapper.dataset.productUrl = productUrl;

          body.innerHTML = '';
          quickbuyWrapper.appendChild(detail);
          body.appendChild(quickbuyWrapper);

          if (typeof window.initPyjamaVariantGalleries === 'function') {
            window.initPyjamaVariantGalleries(quickbuyWrapper);
          }

          const loadedTitle = detail.querySelector('.product__title, .product-title, h1')?.textContent?.trim();
          const loadedPrice = detail.querySelector('.price__current span:last-child, .product-price .price span')?.textContent?.trim();
          this.setDrawerHeader(loadedTitle || title, loadedPrice || price);
        })
        .catch((error) => {
          if (error.name === 'AbortError') return;
          console.warn(error); // eslint-disable-line no-console
          const body = this.drawer.querySelector('[data-pyjama-quickview-body]');
          body.innerHTML = '<p class="pyjama-quickview-drawer__error">Produkt konnte nicht geladen werden.</p>';
        })
        .finally(() => {
          toggle.classList.remove('loading');
          toggle.removeAttribute('aria-busy');
        });
    },

    setDrawerHeader(title, price) {
      const titleEl = this.drawer.querySelector('[data-pyjama-quickview-title]');
      const priceEl = this.drawer.querySelector('[data-pyjama-quickview-price]');
      if (titleEl) titleEl.textContent = title;
      if (priceEl) priceEl.textContent = price;
    },

    setDrawerBodyLoading() {
      const body = this.drawer.querySelector('[data-pyjama-quickview-body]');
      body.innerHTML = '<div class="pyjama-quickview-drawer__loading"><div class="loading-spinner"></div></div>';
    }
  };

  class PyjamaQuickviewDrawer extends SideDrawer {
    connectedCallback() {
      this.addEventListener(`on:${this.dataset.name}:before-close`, () => {
        if (PyjamaMixMatch.abortController) {
          PyjamaMixMatch.abortController.abort();
        }
        const body = this.querySelector('[data-pyjama-quickview-body]');
        if (body) {
          setTimeout(() => {
            body.innerHTML = '<div class="pyjama-quickview-drawer__loading"><div class="loading-spinner"></div></div>';
          }, 400);
        }
      });
    }
  }

  window.PyjamaMixMatch = PyjamaMixMatch;

  if (!customElements.get('pyjama-quickview-drawer')) {
    customElements.define('pyjama-quickview-drawer', PyjamaQuickviewDrawer);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => PyjamaMixMatch.init());
  } else {
    PyjamaMixMatch.init();
  }
})();
